import React from 'react';
import cx from 'classnames';

import T from 'Utilities/texts';

import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';

import investorsList from './investorsConfig';

import styles from './Investors.scss';

const Investors = React.memo(() => (
  <RoundedSection withTopLedge>
    <h2 className={cx('mw-title-title1', styles.title)}>
      {T.translate('aboutPage.investors.title')}
    </h2>
    <p className={cx('mw-title-large', styles.description)}>
      {T.translate('aboutPage.investors.description')}
    </p>
    <div className={styles.investorsBox}>
      <div className={styles.investors}>
        {
          investorsList.map(({
            imgPng,
            imgWebp,
            link,
            name,
          }) => (
            <a key={name} className={styles.logo} href={link} rel="noreferrer" target="_blank">
              <picture>
                {imgWebp && <source srcSet={imgWebp} type="image/webp" />}
                <img
                  key={name}
                  alt={name}
                  height="128"
                  loading="lazy"
                  src={imgPng}
                  width="320"
                />
              </picture>
            </a>
          ))
        }
      </div>
    </div>
  </RoundedSection>
));

export default Investors;
